import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  successTitle: {
    fontSize: 19,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
}));
